{
  "colors": {
    "bar": "color-mix(in srgb, var(--csk-surface) 92%, transparent)",
    "border": "var(--csk-border)",
    "text": "var(--csk-bright)",
    "dim": "var(--csk-muted)",
    "link": "color-mix(in srgb, var(--csk-elevated) 88%, transparent)",
    "linkHover": "var(--csk-accent)",
    "current": "var(--csk-accent)"
  }
}
